import { Pipe, PipeTransform } from '@angular/core';

/**
 * This is for showing "published" status on the Assessments - not the Report. An Assessment's published status is
 * determined by the Report it belongs to AND if there is any "Later" assessment that now overrides this assessment.
 *
 */
@Pipe({
  name: 'reportPublishedStatus'
})
export class ReportPublishedStatusPipe implements PipeTransform {
  transform(searchResult: any): string {
    if (!searchResult) {
      return '';
    }

    if (
      searchResult.editStatus === 'PUBLISHED' &&
      searchResult.publishedStatus === 'CURRENT' &&
      searchResult.latestReportId
    ) {
      return 'NOT_CURRENT';
    }

    return searchResult.publishedStatus;
  }
}
